export default __webpack_public_path__ + "static/media/largedefencepot.c6b1f561.PNG";